import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  ReferenceLine,
} from 'recharts';

const formatShortDate = (dateStr, isRtl) => {
  const d = new Date(dateStr);
  return d.toLocaleDateString(isRtl ? 'ar-SA' : 'en-GB', {
    day: 'numeric',
    month: 'short',
  });
};

const SalesOverTimeChart = ({ data = [], isRtl, formatCurrency, height = 280 }) => {
  if (!data || data.length === 0) {
    return (
      <div className="chart-empty" style={{ height }}>
        <p>{isRtl ? 'لا توجد بيانات مبيعات بعد' : 'No sales data yet'}</p>
        <p className="chart-empty-hint">
          {isRtl ? 'ستظهر المبيعات حسب التاريخ عند توفر الطلبات' : 'Sales by date will appear when orders exist'}
        </p>
      </div>
    );
  }

  const chartData = data.map((d) => ({
    ...d,
    displayDate: formatShortDate(d.date, isRtl),
  }));

  return (
    <div className="sales-chart-container" style={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chartData}
          margin={{ top: 8, right: 20, left: 0, bottom: 8 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
          <XAxis
            dataKey="displayDate"
            tick={{ fontSize: 12, fill: 'var(--text-muted)' }}
            stroke="var(--border)"
            tickLine={false}
          />
          <YAxis
            yAxisId="revenue"
            orientation={isRtl ? 'right' : 'left'}
            tick={{ fontSize: 11, fill: 'var(--text-muted)' }}
            stroke="var(--border)"
            tickLine={false}
            tickFormatter={(v) => (v >= 1000 ? `${(v / 1000).toFixed(0)}K` : v)}
          />
          <YAxis
            yAxisId="orders"
            orientation={isRtl ? 'left' : 'right'}
            tick={{ fontSize: 11, fill: 'var(--text-muted)' }}
            stroke="var(--border)"
            tickLine={false}
          />
          <Tooltip
            contentStyle={{
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--r-md)',
              boxShadow: 'var(--shadow-md)',
            }}
            labelStyle={{ color: 'var(--text)' }}
            formatter={(value, name) => {
              if (name === 'revenue') return [formatCurrency(value), isRtl ? 'الإيرادات' : 'Revenue'];
              if (name === 'orderCount') return [value, isRtl ? 'الطلبات' : 'Orders'];
              return [value, name];
            }}
            labelFormatter={(label) => label}
          />
          <Legend
            wrapperStyle={{ fontSize: 12 }}
            formatter={(value) => (value === 'revenue' ? (isRtl ? 'الإيرادات' : 'Revenue') : (isRtl ? 'الطلبات' : 'Orders'))}
          />
          <ReferenceLine y={0} stroke="var(--border)" />
          <Line
            yAxisId="revenue"
            type="monotone"
            dataKey="revenue"
            name="revenue"
            stroke="var(--primary)"
            strokeWidth={2}
            dot={{ fill: 'var(--primary)', r: 3 }}
            activeDot={{ r: 5 }}
          />
          <Line
            yAxisId="orders"
            type="monotone"
            dataKey="orderCount"
            name="orderCount"
            stroke="var(--success)"
            strokeWidth={2}
            dot={{ fill: 'var(--success)', r: 3 }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesOverTimeChart;
